import { useTranslation } from '../../../components/Translation';
// import EventCard from './EventCard';
import type { LabEvent } from '../../../constants/events/events';

export default function EventsHero({ event, onClick }: { event: LabEvent; onClick: () => void }) {
  const { t } = useTranslation();

  const title = t(`eventos.${event.titleKey}`) !== `eventos.${event.titleKey}` ? t(`eventos.${event.titleKey}`) : event.titleText;
  const description = t(`eventos.${event.descriptionKey}`) !== `eventos.${event.descriptionKey}` ? t(`eventos.${event.descriptionKey}`) : event.descriptionText;

  const formattedDate = new Date(event.date).toLocaleDateString(
    t('eventos.locale') !== 'eventos.locale' ? t('eventos.locale') : 'es-MX',
    { year: 'numeric', month: 'long', day: 'numeric' }
  );

  return (
    <div
      onClick={onClick}
      className="group cursor-pointer rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 flex flex-col md:flex-row h-auto md:h-80 border border-white/60"
      style={{
        background: "rgba(255,255,255,0.7)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow: "0 4px 24px rgba(13,31,53,0.08), inset 0 1px 0 rgba(255,255,255,0.8)"
      }}
    >
      <div className="relative w-full md:w-1/2 h-56 md:h-full overflow-hidden">
        <img
          src={event.imageSrc}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 text-micro font-bold px-3 py-1 rounded-full bg-dorado-uady text-white">
          {t('eventos.status_destacado')}
        </span>
      </div>
      <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
        {event.categoryKey && (
          <span className="text-micro font-bold uppercase text-dorado-uady tracking-widest mb-2">
            {t(`eventos.${event.categoryKey}`)}</span>
        )}
        <h2 className="text-xl md:text-2xl font-bold text-azul-uady mb-3 leading-snug">
          {title}
        </h2>
        <p className="text-mini text-gray-600 leading-relaxed text-justify mb-4 line-clamp-3">
          {description}
        </p>
        <div className="flex items-center gap-2 text-mini text-gray-500">
          <span>📅</span>
          <span className="capitalize">{formattedDate}</span>
        </div>
        {event.location && (
          <div className="flex items-center gap-2 text-mini text-gray-500 mt-1">
            <span>📍</span>
            <span>{event.location}</span>
          </div>
        )}
      </div>
    </div>
  );
}
